import { Component, OnInit } from "@angular/core";
import {
  AsyncValidatorFn,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { error } from "protractor";
import { ResetPassObj } from "src/app/models/login";
import { AccountService } from "src/app/services/account.service";
import { CustomValidators } from "./custom-validators";
import Swal from "sweetalert2";
import { Router } from "@angular/router";

@Component({
  selector: "app-forget-password",
  templateUrl: "./forget-password.component.html",
  styleUrls: ["./forget-password.component.scss"],
})
export class ForgetPasswordComponent implements OnInit {
  resetPassObj: ResetPassObj = {} as ResetPassObj;
  showPassword1: boolean = false;
  showPassword2: boolean = false;
  resetPassWordForm: FormGroup;
  passwordStepper: any;
  lang: string;
  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private translate: TranslateService,
    private router: Router,
    private accService: AccountService
  ) {}

  ngOnInit(): void {
    this.lang = this.translate.currentLang
    this.passwordStepper = 1;
    this.resetPassWordForm = new FormGroup(
      {
        OTP: new FormControl(
          null,
          Validators.compose([
            // check whether the entered password numbers Only
            Validators.required,
          ])
        ),
        firstNewPassword: new FormControl(
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true,
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true,
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true,
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true,
              }
            ),
            Validators.minLength(8),
          ])
        ),
        reFirstNewPassword: new FormControl(
          null,
          Validators.compose([Validators.required])
        ),
        secondNewPassword: new FormControl(
          null,
          Validators.compose([
            // check whether the entered password numbers Only

            Validators.required,
            Validators.pattern("^[0-9]{6}$"),
            // Validators.minLength(4),
            // Validators.maxLength(6)
          ])
        ),
        reSecondNewPassword: new FormControl(
          null,
          Validators.compose([Validators.required])
        ),
      },
      [
        CustomValidators.firstPasswordMatchValidator as AsyncValidatorFn,
        CustomValidators.secondPasswordMatchValidator as AsyncValidatorFn,
      ]
    );
  }

  onSubmit() {
    this.resetPassObj.password = this.resetPassWordForm.value.firstNewPassword;
    this.resetPassObj.secondPassword =
      this.resetPassWordForm.value.secondNewPassword;
    this.resetPassObj.otp = this.resetPassWordForm.value.OTP;
    this.recaptchaV3Service
      .execute("importantAction")
      .subscribe((token: string) => {
        this.accService.resetPassword(this.resetPassObj).subscribe(
          (arg) => {
           let resMsg :any;
           resMsg = arg
            if(resMsg.IsSuccess == true){
              this.router.navigate(["/login"]);
            Swal.fire({
              position: "center",
              icon: "success",
              title: this.translate.instant("pass-success-msg"),
              showConfirmButton: false,
              timer: 4500,
            });
            }else{
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("pass-error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
            }
          },
          (err) => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: this.translate.instant("pass-error-msg"),
              showConfirmButton: false,
              timer: 4500,
            });
          }
        );
      });
  }
  next() {
    this.showPassword1 = false;
    this.showPassword2 = false;
    this.passwordStepper = this.passwordStepper + 1;
  }
  back() {
    this.showPassword1 = false;
    this.showPassword2 = false;
    this.passwordStepper = this.passwordStepper - 1;
  }
}
